export default "__VITE_ASSET__CWYDbtK2__"